import Immutable from 'immutable';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { appointmentStatusStyle } from '../../../lib/calendarSharedMethods';
import { Button } from '../../shared/_form';

const Appointment = function({ appointment, books, hideModal, showModal }) {
  const startTime = moment(appointment.get('scheduledOn'), 'YYYY-MM-DD').startOf('day').add(appointment.get('from'), 'seconds');
  const book      = (books.get('data') || Immutable.Map()).get(appointment.get('office')) || Immutable.Map();


  return (
    <Fragment>
      <Link className='rep-calendar-index__list__container__row' to={ `/reps/calendar/${appointment.get('scheduledOn')}/${appointment.get('id')}` }>
        <div className='rep-calendar-index__list__container__row__left'>
          <div className={ 'rep-calendar-index__item' }>
            <div className={ 'rep-calendar-index__item--date' }>{ startTime.format('h:mm A') } at {' '}</div>
            <div >{ book.get('name') }</div>
          </div>
          <div className={ `rep-calendar-index__item ${appointmentStatusStyle(appointment.get('status'))}` }>{ appointment.get('status') }</div>
        </div>
        <div className='rep-calendar-index__list__container__row__right'>
          <i className='fa fa-angle-right rep-calendar-index__list__icon' />
        </div>

      </Link>
    </Fragment>
  );
};

Appointment.propTypes = {
  appointment: PropTypes.instanceOf(Immutable.Map),
  books:       PropTypes.instanceOf(Immutable.Map),
};

const mapStateToProps = (state) => {
  return {
    books: state.get('books')
  };
};

export default connect(mapStateToProps)(Appointment);



// WEBPACK FOOTER //
// ./app/components/reps/calendar/_Appointment.jsx